import { getFilters } from "../../utils/commonUtils";
import { commonBaseApiSlice } from "../commonBaseApiSlice";

export const approvalWorkflowApiSlice = commonBaseApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getApprovalWorkflows: builder.mutation({
      query: (data) => ({
        url: `/mckesson/getapprovalworkflows?${getFilters(data)}`,
        method: "GET",
      }),
    }),
    createApprovalWorkflow: builder.mutation({
      query: (data) => ({
        url: "/approvalworkflow/create",
        method: "POST",
        body: data,
      }),
    }),
    editApprovalWorkflow: builder.mutation({
      query: (data) => ({
        url: "/mckesson/putapprovalworkflow",
        method: "PUT",
        body: data,
      }),
    }),
    getApprovalWorkflowById: builder.mutation({
      query: (id) => ({
        url: `/mckesson/getapprovalworkflowbyid?id=${id}`,
        method: "GET",
      }),
    }),
    deleteApprovalWorkflow: builder.mutation({
      query: (data) => ({
        url: `/mckesson/deleteapprovalworkflow?id=${data.id}`,
        method: "DELETE",
      }),
    }),
    getApprovalModes: builder.mutation({
      query: () => ({
        url: `/mckesson/getapprovalmodes`,
        method: "GET",
      }),
    }),
    duplicateApprovalWorkflow: builder.mutation({
      query: (data) => ({
        url: `/approvalworkflow/duplicate?${getFilters(data)}`,
        method: "POST",
      }),
    }),
    postApprovalWorkflow: builder.mutation({
      query: (data) => ({
        url: "/mckesson/postapprovalworkflow",
        method: "POST",
        body: data,
      }),
    }),
    postApproverDetail: builder.mutation({
      query: (data) => ({
        url: "/mckesson/postapproverdetail",
        method: "POST",
        body: data,
      }),
    }),
    putApproverDetail: builder.mutation({
      query: (data) => ({
        url: "/mckesson/putapproverdetail",
        method: "PUT",
        body: data,
      }),
    }),
    deleteApproverDetail: builder.mutation({
      query: (id) => ({
        url: `/mckesson/deleteapproverdetail?id=${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetApprovalWorkflowsMutation,
  useCreateApprovalWorkflowMutation,
  useEditApprovalWorkflowMutation,
  useGetApprovalWorkflowByIdMutation,
  useDeleteApprovalWorkflowMutation,
  useGetApprovalModesMutation,
  useDuplicateApprovalWorkflowMutation,
  usePostApprovalWorkflowMutation,
  usePostApproverDetailMutation,
  usePutApproverDetailMutation,
  useDeleteApproverDetailMutation,
} = approvalWorkflowApiSlice;
